// Hand-curated customer reviews shown on /, /Download, and /Reviews.
// To update: edit this file, then redeploy.
//
// Fields:
//   id           — any unique string (just for React keys)
//   customerName — display name, can be initials/first-name-last-initial
//   rating       — 1–5
//   text         — the quote (no surrounding quote marks needed; multi-paragraph OK with \n\n)
//   source       — optional: 'Google' | 'Email' | 'Reddit' | 'Yelp' | etc.
//   date         — free-form display string ('March 2026', 'Spring 2026')
//   featured     — optional: true to show on homepage + /Download strip

export const reviews = [
  {
    id: 'vincenzo-2026-03',
    customerName: 'Vincenzo G.',
    rating: 5,
    text: `The Bins Storage team was awesome — super professional and always quick to respond. The movers packed everything in under an hour but were really careful with my stuff, and their storage rates are by far the best I found in the Bay Area. I'd 100% recommend them.`,
    date: 'March 2026',
    featured: true,
  },
  {
    id: 'trevor-2026-04',
    customerName: 'Trevor T.',
    rating: 5,
    text: `Honestly, the valet service has been great. Albert and Bobby are super responsive, professional, and helpful. They have an app that makes everything easy to schedule and track. Some of my friends were also looking for storage, but most of the other options on Reddit were way more expensive — especially now we don't have Gigs, driving to locations is hard. So Bins has been a solid option.`,
    date: 'April 2026',
    featured: true,
  },
  {
    id: 'iris-2026-05',
    customerName: 'Iris M.',
    rating: 5,
    text: `Great! The moving services, item tagging, and costs were perfect.`,
    date: 'May 2026',
    featured: true,
  },
];
